import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[inputFocus]'
})
export class InputFocusDirective {
  element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e) {
    if ((e.which === 13 || e.keyCode === 13)) {
      const inputs = document.getElementsByClassName('form-control');
      const index = Object.keys(inputs)
        .findIndex((key) => inputs[key].name === this.element.nativeElement.name);
      const nextElement = inputs[index + 1];
      if (nextElement) {
        e.preventDefault();
        (nextElement as any).focus();
      }
      return;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/input-focus.directive.ts